import classes from './InputForm.module.css';
import React, { useState, useContext } from 'react';
import Modal from '../../UI/Modal';
import NoteCard from '../../UI/NoteCard';
import Masonry from 'react-masonry-component';
import NotesContext from '../../store/notes-context';
import { v4 as uuidv4 } from 'uuid';

const masonryOptions = {
  transitionDuration: 100,
  gutter: 0,
};

export default function InputForm() {
  const [showForm, setShowForm] = useState(false);
  const [note, setNote] = useState('');
  const [title, setTitle] = useState('');

  const notesCtx = useContext(NotesContext);
  const searchText = notesCtx.searchText;

  const toggleModal = () => {
    setShowForm((prevState) => !prevState);
  };

  const onNoteChange = (e) => {
    setNote(e.target.value);
  };

  const onTitleChange = (e) => {
    setTitle(e.target.value);
  };

  const addNote = (e) => {
    e.preventDefault();
    toggleModal();

    if (title.trim() === '' && note.trim() === '') {
      return;
    }

    let id = uuidv4();

    notesCtx.addNote({ title, note, id });
    setNote('');
    setTitle('');
  };

  const notesArray = notesCtx.notes;

  const notes = notesArray
    .filter((val) => {
      if (searchText === '') {
        return val;
      } else if (val.title.toLowerCase().includes(searchText.toLowerCase())) {
        return val;
      } else {
        return null;
      }
    })
    .slice(0)
    .reverse()
    .map((note) => {
      return (
        <NoteCard note={note} key={note.id}>
          {note.title && <h4 style={{ marginTop: '0' }}>{note.title}</h4>}
          {note.note && <p>{note.note}</p>}
        </NoteCard>
      );
    });

  return (
    <div className={classes['inp-frm']}>
      {!showForm && (
        <input
          className={classes.inp}
          type="text"
          onClick={() => {
            setShowForm(true);
          }}
          placeholder="Take a note..."
        />
      )}
      {showForm && (
        <Modal setShowForm={toggleModal}>
          <form action="" className={classes['modal-form']} onSubmit={addNote}>
            <input
              type="text"
              placeholder="Title here..."
              value={title}
              onChange={onTitleChange}
              autoFocus
            />
            <textarea
              contentEditable
              name=""
              id=""
              cols="10"
              rows="20"
              placeholder="Take a note..."
              value={note}
              onChange={onNoteChange}
            ></textarea>
            <div className={classes.btn}>
              <button type="submit">Close</button>
              <button type="submit">Create</button>
            </div>
          </form>
        </Modal>
      )}
      <div className={classes.notes}>
        <div className={classes.item}>
          <Masonry options={masonryOptions}>{notes}</Masonry>
        </div>
      </div>
    </div>
  );
}
